// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

/** Supported answer values for the patient-facing CPAP/BiPAP intake question. */
export const CPAP_BIPAP_USE_ANSWERS = [
  'Yes, and I am currently using it',
  'Yes, but I could not tolerate it',
  'Yes, but it was not effective',
  'No, I have not used a CPAP or BiPAP before',
] as const;

export type CpapBipapUseAnswer = (typeof CPAP_BIPAP_USE_ANSWERS)[number];

/** Supported answer values for the patient-facing oral-appliance intake question. */
export const ORAL_APPLIANCE_USE_ANSWERS = [
  'Yes, and I am currently using it',
  'Yes, but I could not tolerate it',
  'Yes, but it was not effective',
  'No, I have not used an oral device before',
] as const;

export type OralApplianceUseAnswer = (typeof ORAL_APPLIANCE_USE_ANSWERS)[number];

/** Coding used by checkbox questions for an explicit negative selection. */
export const NONE_OF_THE_ABOVE_CODE = 'none' as const;
